import axios from 'axios'
import { setAuthorizationHeader } from '../utils/authorizationUtils'
import { AD_PLATFORM_TYPE } from '../features/crux/cruxConstants'
import { cruxAccountJoin, kakaoLogin } from '../features/login/kakaoAccount'

const { REACT_APP_CRUX_API_HOST, NODE_ENV } = process.env
const cruxAxios = axios.create({
  baseURL: REACT_APP_CRUX_API_HOST,
  withCredentials: true,
})
cruxAxios.interceptors.request.use(
  config => {
    config.headers.set('serviceType', AD_PLATFORM_TYPE)
    return setAuthorizationHeader(config)
  },
  error => Promise.reject(error)
)
cruxAxios.interceptors.response.use(
  response => {
    const { headers } = response
    const accessToken = headers.get('x-access-token')
    if (accessToken) {
      sessionStorage.setItem('accessToken', accessToken)
    }
    return response
  },
  error => {
    const status = error.response?.status
    const errorCode = error.response?.data?.errorCode
    const message = error.response?.data?.message
    const component = error.response?.data?.component

    if (NODE_ENV === 'development') {
      console.error({
        status,
        data: error.response?.data,
      })
    }

    if (status === 401 && component === 'CRUX_ACCOUNT') {
      cruxAccountJoin()
      return
    } else if (component === 'BIZGW') {
      kakaoLogin()
      return
    }

    if (errorCode) {
      error.code = errorCode
    }
    if (message) {
      error.message = message
    }
    return Promise.reject(error)
  }
)
export default cruxAxios
